'use strict';

export default class AddController {

    /*@ngInject*/
    constructor($http, $state) {
        this.$http = $http;
        this.$state = $state;
        this.newList = {};
    }

    save() {
        this.$http.post(`/api/booklists`, this.newList).then(res => {
            this.$state.go('^');
        });
    }

}



// WEBPACK FOOTER //
// ./client/app/booklist/add/add.controller.js